import { useForm } from '@/features/shiftCloseouts/form'
import { ShiftCloseoutPaymentMethod } from '@/features/shiftCloseouts/types'
import { FC, ReactNode } from 'react'
import { FormProvider } from 'react-hook-form'

interface ProviderProps {
    children: ReactNode
    paymentMethods: ShiftCloseoutPaymentMethod[]
}

const Provider: FC<ProviderProps> = ({ children, paymentMethods }) => {
    const form = useForm(paymentMethods)

    return <FormProvider {...form}>{children}</FormProvider>
}

export default Provider
